import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import RoleForm from "components/roles/RoleForm";
import {
  createRole,
  createRolePermission,
  createRoleUser,
} from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const RoleCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const role = {
    name: "",
    description: "",
    users: [],
    permissions: [],
    companyID: me.companyID ?? "",
  };

  async function onSubmit(values) {
    try {
      const { name, description, users, permissions, companyID } = values;

      const role = (
        await API.graphql({
          query: createRole.replaceAll("__typename", ""),
          variables: {
            input: {
              name,
              description,
              companyID,
            },
          },
        })
      )?.data?.createRole;

      const promises = [];

      promises.push(
        ...users.reduce((promises, user) => {
          promises.push(
            API.graphql({
              query: createRoleUser.replaceAll("__typename", ""),
              variables: {
                input: {
                  roleId: role.id,
                  userId: user.id,
                },
              },
            })
          );
          return promises;
        }, [])
      );

      promises.push(
        ...permissions.reduce((promises, permission) => {
          promises.push(
            API.graphql({
              query: createRolePermission.replaceAll("__typename", ""),
              variables: {
                input: {
                  roleId: role.id,
                  permissionId: permission.id,
                },
              },
            })
          );
          return promises;
        }, [])
      );

      await Promise.all(promises);

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/roles");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <RoleForm onSubmit={onSubmit} initialValues={role} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Rol",
    successAdded: "Rol agregado con éxito",
    responses: {},
  },
});

export default RoleCreateForm;
